import React, { useEffect, useState } from "react";

interface TimerProps {
    targetTime: string; // ISO 8601 format or similar (e.g., "2024-11-20T15:00:00")
    additionalSeconds?: number; // Extra seconds to add to the target time
    setCountDown?: (difference: number) => void
}

const TimerDisplay: React.FC<TimerProps> = ({ targetTime, additionalSeconds = 0, setCountDown }) => {
    const [timeRemaining, setTimeRemaining] = useState({
        hours: 0,
        minutes: 0,
        seconds: 0,
    });

    useEffect(() => {
        // Calculate the final target time by adding additionalSeconds
        const finalTargetTime = new Date(new Date(targetTime).getTime() + additionalSeconds * 1000);
        console.log(" target_time " , targetTime , " now time " ,  finalTargetTime);
        const calculateTimeRemaining = () => {
            const now = new Date().getTime();
            const target = finalTargetTime.getTime();
            const difference = target - now;
            if (setCountDown) {
                setCountDown(difference);
            }
            if (difference > 0) {
                const hours = Math.floor((difference / (1000 * 60 * 60)) % 24);
                const minutes = Math.floor((difference / (1000 * 60)) % 60);
                const seconds = Math.floor((difference / 1000) % 60);

                setTimeRemaining({ hours, minutes, seconds });
            } else {
                setTimeRemaining({ hours: 0, minutes: 0, seconds: 0 });

            }
        };

        calculateTimeRemaining(); // Initial calculation
        const interval = setInterval(calculateTimeRemaining, 1000); // Update every second

        return () => clearInterval(interval); // Cleanup interval on unmount
    }, [targetTime, additionalSeconds]);


    return (
        <span>
            {String(timeRemaining.hours).padStart(2, "0")}:
            {String(timeRemaining.minutes).padStart(2, "0")}:
            {String(timeRemaining.seconds).padStart(2, "0")}
        </span>
    );
};

export default TimerDisplay;